module.exports = __webpack_public_path__ + "fonts/ubuntu-ruble-regular.2bf18d4.woff";